import { QUESTION_ID } from 'modules/questionnaire/questionIds';
import IntakeAboutYou from './renderers/IntakeAboutYou';
import SingleOptionSelect from './renderers/SingleOptionSelect';
import MultipleOptionSelect from './renderers/MultipleOptionSelect';
import TreatmentQuestion from './renderers/TreatmentQuestion';
import MultiPages from './renderers/MultiPages';
import Biomarkers from './renderers/Biomarkers';
import MonthPicker from './renderers/MonthPicker';
import { SearchSelect } from './renderers/SearchSelect/SearchSelect';
import IntakeLocation from './renderers/IntakeLocation';
import DrugsReceived from './renderers/DrugsReceived';
import TextInput from './renderers/TextInput';
import NumberInput from './renderers/NumberInput';
import { DrugsReceivedSearchSelect } from './renderers/DrugsReceivedSearchSelect';
import { QUESTION_TYPE } from './constants';

const {
  treatments: {
    subQuestionIds: {
      drugs_received: DRUGS_RECEIVED,
    },
  },
  procedures: {
    subQuestionIds: {
      procedures_received: PROCEDURES_RECEIVED,
    },
  },
  insurances: INSURANCES,
} = QUESTION_ID;

export const RENDERER_BY_QUESTION_TYPE = {
  [QUESTION_TYPE.INTAKE_ABOUT_YOU]: IntakeAboutYou,
  [QUESTION_TYPE.SINGLE_OPTION_SELECT]: SingleOptionSelect,
  [QUESTION_TYPE.MULTIPLE_OPTION_SELECT]: MultipleOptionSelect,
  [QUESTION_TYPE.TREATMENT_HISTORY]: TreatmentQuestion,
  [QUESTION_TYPE.COMPOSITE]: TreatmentQuestion,
  [QUESTION_TYPE.PROCEDURES]: MultiPages,
  [QUESTION_TYPE.BIOMARKERS]: Biomarkers,
  [QUESTION_TYPE.MONTH_PICKER]: MonthPicker,
  [QUESTION_TYPE.MULTIPLE_OPTION_SEARCH_SELECT]: SearchSelect,
  [QUESTION_TYPE.INTAKE_LOCATION]: IntakeLocation,
  [QUESTION_TYPE.DRUGS_RECEIVED]: DrugsReceived,
  [QUESTION_TYPE.TEXT_INPUT]: TextInput,
  [QUESTION_TYPE.NUMBER_INPUT]: NumberInput,
};

const OPTIONS_FROM_SERVER_RENDERER_BY_QUESTION_ID = {
  [DRUGS_RECEIVED]: DrugsReceivedSearchSelect,
  [PROCEDURES_RECEIVED]: SearchSelect,
  [INSURANCES]: SearchSelect,
};

export const getQuestionRenderer = ({
  id,
  type,
}) => {
  if (type === QUESTION_TYPE.OPTIONS_FROM_SERVER) {
    return OPTIONS_FROM_SERVER_RENDERER_BY_QUESTION_ID[id];
  }
  return RENDERER_BY_QUESTION_TYPE[type];
};
